module.exports = __webpack_public_path__ + "static/media/icon-baby-full-disabled.65e49c80.png";